import * as React from 'react'
import {ContactForm} from './ContactForm'

export const Contact = () => {
  return (
    <div className='AI__contact AI__contact--mt' id='contact'>
      <div className='AI__contact__content'>
        <p>ติดต่อเรา</p>
        <h2>Contact us</h2>
        <p>
          มีข้อเสนอ
          <br />
          สงสัยอยากสอบถาม
        </p>
      </div>

      <ContactForm />
    </div>
  )
}
